import { SelectItem } from '../../types';

export const ACTION = {
  CLEAR_TARGET_STATE: 'SELECTION_REPORT:CLEAR_TARGET_STATE',
  REQUEST_TARGET_FIELDS: 'SELECTION_REPORT:REQUEST_TARGET_FIELDS',
  RESPONSE_TARGET_FIELDS: 'SELECTION_REPORT:RESPONSE_TARGET_FIELDS',
  REQUEST_TARGET_DEFAULT_FIELDS: 'SELECTION_REPORT:REQUEST_TARGET_DEFAULT_FIELDS',
  RESPONSE_TARGET_DEFAULT_FIELDS: 'SELECTION_REPORT:RESPONSE_TARGET_DEFAULT_FIELDS',
  UPDATE_DEFAULT_TARGET_FIELDS: 'SELECTION_REPORT:UPDATE_DEFAULT_TARGET_FIELDS'
};

export class ClearTargetState {
  public type: string = ACTION.CLEAR_TARGET_STATE;
  constructor(public instanceKey: string) {}
} 
export class RequestTargetDefaultFields {
  public type: string = ACTION.REQUEST_TARGET_DEFAULT_FIELDS;
  constructor(public instanceKey: string) {}
}
export class ResponseTargetDefaultFields {
  public type: string = ACTION.RESPONSE_TARGET_DEFAULT_FIELDS;
  constructor(public instanceKey: string, public options: SelectItem[]) { }
}
export class UpdateTargetDefaultFields {
  public type: string = ACTION.UPDATE_DEFAULT_TARGET_FIELDS;
  constructor(public instanceKey: string, public options: SelectItem[]) { }
}
export class ResponseTargetFields {
  public type: string = ACTION.RESPONSE_TARGET_FIELDS;
  constructor(public instanceKey: string, public options: SelectItem[]) { }
}
